module.exports = __webpack_public_path__ + "images/a73c5a278c2a3ea3335c0979f8d88bb4.png";